import { FC } from 'react'
import Button, { ButtonSize, ButtonTheme } from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { ONBOARDING_REGISTER } from 'constants/pages'
import * as styles from 'components/features/pfm/JoinButton/JoinButton.styl'
import { ShadowKind } from 'interfaces/component'

type JoinButtonProps = {
  size?: ButtonSize
  theme?: ButtonTheme
  fullWidth?: boolean
  fullHeight?: boolean
  shadow?: ShadowKind
}


const JoinButton: FC<JoinButtonProps> = (props) => {
  const { children, size, shadow, theme } = props

  const defaultChildren = (
    <div className={ styles.contentWrapper }>
      <span className={ styles.mainCta }>Join Status</span>
      <span className={ styles.secondaryCta }>Earn $5 Reward</span>
    </div>
  )

  return (
    <NavigationLink to={ ONBOARDING_REGISTER }>
      <Button
        size={ size }
        theme={ theme }
        shadow={ shadow }
        qaMarker='join-status-button'
      >
        { children || defaultChildren }
      </Button>
    </NavigationLink>
  )
}

JoinButton.defaultProps = {
  size: 'responsive',
  theme: 'blue',
}

export default JoinButton
